import { useState, useEffect, useContext } from 'react';
import { useNavigate, useMatch } from 'react-router-dom';
import { UserDetailsContext } from "../contexts/UserDetailsProvider";
import AuthUtils from "../utils/authUtils";


const useCohortTrainerAccessCheck = (cohortId: string | undefined) => {
    const { userDetails } = useContext(UserDetailsContext);
    const [cohortTrainerAccessAuthorized, setCohortTrainerAccessAuthorized] = useState(false);
    const navigate = useNavigate();
    const isTrainerPage = useMatch("/trainer/*");
    useEffect(() => {
        async function performAccessCheck(shouldRedirect) {
            if (cohortId) {
                if (await AuthUtils.hasCohortTrainerAccess(userDetails, cohortId)) {
                    setCohortTrainerAccessAuthorized(true);
                } else if (shouldRedirect) {
                    console.warn("Cohort trainer access denied. Redirecting to trainer homepage.");
                    navigate("/trainer");
                    window.location.reload();
                } else {
                    console.warn("Cohort trainer access denied.");
                }
            }
        }
        // Since this access check is used in the trainer sidebar, which is visible on the practice case
        // page, only perform the redirect on trainer-specific pages. This logic is necessary as trainers
        // will access the practice case page both when creating a new practice case, as well as when
        // participating in training as learners.
        performAccessCheck(isTrainerPage);
    }, [cohortId, userDetails, isTrainerPage]);
    return {
        cohortTrainerAccessAuthorized
    };
}

export default useCohortTrainerAccessCheck;